import { msg } from "@lingui/core/macro";

/**
 * Messages reused across multiple files. Sharing one descriptor keeps the
 * wording (and thus the catalog entry and its translations) from diverging.
 */
export const genericErrorMsg = msg`An error occurred. Please try again later.`;

/** After an AFib probability label, until the algorithm is certified. */
export const afibDisclaimerMsg = msg`For information only. Not yet certified (MDR Class IIa certification in progress). Not for diagnosis or treatment decisions.`;
